import React from "react";
import {ButtonBase, CircularProgress, IconButton, Slider, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Cancel01Icon, PauseIcon, PlayIcon} from "@hugeicons/core-free-icons";
import {formatTime} from "../utils/functions";

export const AudioBar = ({
  playing, loading = false, currentTime, duration, rate, onToggle, onSeek, onCycleRate, onClose, sx,
}) => (
  <Stack direction={"row"} alignItems={"center"} gap={1.25} sx={{
    boxSizing: "border-box", height: 46, maxWidth: 440, width: "100%", mx: "auto", pl: 0.75, pr: {xs: 1.5, md: 1}, borderRadius: "999px",
    bgcolor: "#fff", border: "1px solid #ECECF3", boxShadow: "0 4px 16px rgba(75, 85, 201, 0.1)", ...sx,
  }}>
    <IconButton onClick={onToggle} disabled={loading} aria-label={playing ? "Pause" : "Play"} sx={{
      width: 34, height: 34, flexShrink: 0, color: "#4B55C9", bgcolor: "rgba(132, 145, 247, 0.2)",
      "&:hover": {bgcolor: "rgba(132, 145, 247, 0.3)"},
    }}>
      {loading
        ? <CircularProgress size={14} sx={{color: "#4B55C9"}}/>
        : playing ? <HugeiconsIcon icon={PauseIcon} size={15}/> : <HugeiconsIcon icon={PlayIcon} size={15} strokeWidth={2}/>}
    </IconButton>
    <Typography sx={{fontSize: 12, fontWeight: 600, color: "#23264D", fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap"}}>
      {formatTime(currentTime)}
    </Typography>
    <Slider
      size={"small"}
      min={0}
      max={duration || 1}
      step={0.1}
      value={currentTime}
      onChange={(e, value) => onSeek(value)}
      sx={{
        flex: 1, minWidth: 0, py: 0, color: "#8491F7", height: 4,
        "& .MuiSlider-rail": {color: "#E4E4EE", opacity: 1},
        "& .MuiSlider-thumb": {
          width: 12, height: 12, bgcolor: "#fff", border: "2px solid #8491F7", boxShadow: "none",
          "&:hover, &.Mui-focusVisible, &.Mui-active": {boxShadow: "0 0 0 4px rgba(132, 145, 247, 0.2)"},
        },
      }}
    />
    <Typography sx={{
      display: {xs: "none", sm: "block"}, fontSize: 12, color: "#8A8AA0", fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap",
    }}>
      {formatTime(duration)}
    </Typography>
    {onCycleRate && (
      <ButtonBase onClick={onCycleRate} aria-label={"Playback speed"} sx={{
        display: {xs: "none", sm: "flex"}, flexShrink: 0, height: 28, minWidth: 40, px: 1, borderRadius: "999px",
        fontSize: 11, fontWeight: 700, color: "#4B55C9", bgcolor: "rgba(132, 145, 247, 0.14)",
        "&:hover": {bgcolor: "rgba(132, 145, 247, 0.22)"},
      }}>
        {rate}×
      </ButtonBase>
    )}
    {onClose && (
      <IconButton onClick={onClose} aria-label={"Close player"} size={"small"} sx={{color: "#8A8AA0"}}>
        <HugeiconsIcon icon={Cancel01Icon} size={14}/>
      </IconButton>
    )}
  </Stack>
);
